import React from 'react';
import styles from '../../styles/CambioGrupoStyles/CambioGrupo.module.css';

function StudentResults({ students, onStudentSelect }) {
  if (students.length === 0) {
    return (
      <div className={styles.noResults}>
        <p>No se encontraron estudiantes con los criterios de búsqueda.</p>
      </div>
    );
  }

  return (
    <div className={styles.resultsContainer}>
      <div className={styles.resultsTable}>
        <div className={styles.tableHeader}>
          <div className={styles.headerCell}>Nombre</div>
          <div className={styles.headerCell}>Matrícula</div>
          <div className={styles.headerCell}>Campus</div>
          <div className={styles.headerCell}>Sección</div>
          <div className={styles.headerCell}>Programa</div>
          <div className={styles.headerCell}>Ciclo Escolar</div>
        </div>
        
        <div className={styles.tableBody}>
          {students.map((student) => (
            <div 
              key={student.id} 
              className={styles.tableRow}
              onClick={() => onStudentSelect(student)}
            >
              <div className={styles.tableCell}>
                <span 
                  className={styles.studentName}
                  onClick={(e) => {
                    e.stopPropagation();
                    onStudentSelect(student);
                  }}
                >
                  {student.nombre}
                </span>
              </div>
              <div className={styles.tableCell}>{student.matricula}</div>
              <div className={styles.tableCell}>{student.campus}</div>
              <div className={styles.tableCell}>{student.seccion}</div>
              <div className={styles.tableCell}>{student.programa}</div>
              <div className={styles.tableCell}>{student.cicloEscolar}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StudentResults;
